/**
 * تفصيل مديرية واحدة عبر المحافظات — يقرأ المدى من رابط الصفحة
 */
import React, { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import DateRangeFilter, { defaultRange } from "../../components/shared/DateRangeFilter";
import type { DateRange } from "../../components/shared/DateRangeFilter";
import PivotTable from "../../components/shared/PivotTable";
import PrintLayout from "../../components/Layout/PrintLayout";
import { formatDate } from "../../lib/date";
import { useReport, exportCsv } from "./useReport";
import MeasureToggle from "../../components/shared/MeasureToggle";
import { MEASURE_LABELS } from "../../types";
import type { Measure } from "../../types";

export default function SummaryDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [sp] = useSearchParams();
  const navigate = useNavigate();

  const [range, setRange] = useState<DateRange>(() => {
    const from = sp.get("from"), to = sp.get("to");
    return from && to ? { from, to } : defaultRange();
  });

  const PATH = `/reports/directorate/${id}`;
  const [measure, setMeasure] = useState<Measure>("requested");
  const { data, isLoading, error } = useReport(PATH, range, !!id, measure);

  return (
    <div>
      <div className="page-header flex items-start justify-between">
        <div>
          <button className="text-sm text-primary-600 hover:underline mb-1 print:hidden"
            onClick={() => navigate("/summary/directorates")}>
            ← رجوع إلى الملخص
          </button>
          <h1 className="page-title">ما تم طلبه{data?.title ? ` — ${data.title}` : ""}</h1>
          <p className="page-subtitle">طلبات المديرية يوماً بيوم ضمن المدى المحدد</p>
        </div>
        <div className="flex gap-2 print:hidden">
          <button className="btn-secondary" onClick={() => exportCsv(PATH, range, measure)} disabled={!data}>
            تصدير CSV
          </button>
          <button className="btn-secondary" onClick={() => window.print()} disabled={!data}>
            طباعة
          </button>
        </div>
      </div>

      <div className="print:hidden">
        <DateRangeFilter value={range} onChange={setRange} />
      </div>
      <MeasureToggle value={measure} onChange={setMeasure} />

      {isLoading && <div className="card text-center text-gray-400 py-10">جاري التحميل...</div>}
      {error     && <div className="alert-error">تعذّر تحميل التقرير</div>}
      {data      && <PrintLayout title={`${MEASURE_LABELS[measure]}${data?.title ? ` — ${data.title}` : ""}`} subtitle={`من ${formatDate(range.from)} إلى ${formatDate(range.to)}`}><PivotTable report={data} firstColLabel="يوم التنفيذ" /></PrintLayout>}
    </div>
  );
}
